module.exports = __webpack_public_path__ + "static/media/home-icon2.4ddf5bee.svg";